module.exports = __webpack_public_path__ + "img/Intro-Scenario.8933683e.png";